import { FeatureFlags, Permission } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../types';

const path = PAGE_PATHS.AGENTIC_SOC;

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/agentic-soc/')({
  beforeLoad: ({ context, preload }) => {
    const allowedFFIncidentWorkflow = !!context.featureFlags[FeatureFlags.ShowIncidentFlow];
    const isAllowed = context.userPermissions.hasAllowedPermission({ path, permission: Permission.READ }) && allowedFFIncidentWorkflow;
    context.validatePermissions({ isAllowed, preload });
  },
});
